import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

export interface ScopeTypeItem {
  type: string;
  description: string;
}

export interface ScopeTypesResponse {
  scope_types: ScopeTypeItem[];
}

const SCOPE_TYPES_ENDPOINT = "/api/v1/admin/rbac/scopes/types";

/**
 * Fetches the list of scope types from the API.
 */
export const getScopeTypes = async (): Promise<ScopeTypeItem[]> => {
  const response = await api.get(SCOPE_TYPES_ENDPOINT, undefined);

  if (response && typeof response === "object" && "scope_types" in response) {
    const data = response as ScopeTypesResponse;
    return Array.isArray(data.scope_types) ? data.scope_types : [];
  }

  return [];
};
